var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1089_6473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.13143 1.38086H4.64286C3.80932 1.38086 3.00992 1.71198 2.42052 2.30138C1.83112 2.89078 1.5 3.69018 1.5 4.52372V7.66657C1.5 16.3456 8.53529 23.3809 17.2143 23.3809H20.3571C21.1907 23.3809 21.9901 23.0497 22.5795 22.4603C23.1689 21.8709 23.5 21.0715 23.5 20.238V18.0663C23.4998 17.7745 23.4185 17.4886 23.265 17.2405C23.1115 16.9923 22.892 16.7918 22.631 16.6614L18.8344 14.7631C18.6331 14.6624 18.4124 14.6061 18.1874 14.5981C17.9624 14.5901 17.7383 14.6305 17.5303 14.7167C17.3223 14.8028 17.1352 14.9326 16.9817 15.0973C16.8282 15.2621 16.7119 15.4578 16.6407 15.6714L16.174 17.0747C16.0275 17.5144 15.7255 17.8854 15.3247 18.118C14.9239 18.3507 14.452 18.4289 13.9976 18.3381C12.1584 17.9694 10.4693 17.0649 9.14307 15.7383C7.81682 14.4118 6.91262 12.7226 6.54429 10.8833C6.45349 10.4289 6.53178 9.95693 6.76443 9.55615C6.99708 9.15538 7.36808 8.85337 7.80771 8.70686L9.54886 8.12543C9.92406 8.00027 10.2383 7.73823 10.4288 7.3916C10.6193 7.04498 10.672 6.63926 10.5766 6.25543L9.65571 2.57043C9.57059 2.23061 9.37435 1.92899 9.09818 1.71346C8.82201 1.49793 8.48174 1.38087 8.13143 1.38086Z",
    stroke: "white",
    strokeWidth: 1.57143
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1089_6473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.380859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.7dc2126b5b43d51593708bb4327256c4.svg";
export { ForwardRef as ReactComponent };